import React from 'react';
import { func, number, oneOfType, shape, string } from 'prop-types';
import { useIntl } from 'react-intl';

import BaseProductTile from '../BaseProductTile';
import DateSelector from '../atoms/dateSelector/DateSelector';
import StoreSelector from '../atoms/storeSelector/StoreSelector';
import { ENV_CONFIG } from '../../../../../constants/envConfig';

const ChangeDatesOrStoreGrt72Hrs = ({
    tileDetails,
    productRatesDailyWeeklyMonthly,
    accountNumber,
    handleAnchorClick,
    handleRedirectClick,
    showAvailableDates,
    showAvailableStores,
    footerTileClassName,
    footerTileRef,
    ...restProps
}) => {
    const { availableDate, selectDates } = showAvailableDates || {};
    const { availableStores, selectStores } = showAvailableStores || {};
    const intl = useIntl();

    const footerContent = () => {
        return (
            <>
                <StoreSelector
                    availableStores={availableStores}
                    selectStores={selectStores}
                    productName={tileDetails?.producttitle}
                    btnCustomClass={'productTile-hover'}></StoreSelector>
                <DateSelector
                    availabilityDate={availableDate}
                    selectDates={selectDates}
                    productName={tileDetails?.producttitle}
                    btnCustomClass={'productTile-hover'}></DateSelector>
            </>
        );
    };
    return (
        <BaseProductTile
            footerTileClassName={footerTileClassName}
            footerTileRef={footerTileRef}
            productUrl={tileDetails?.producturl}
            productImg={tileDetails?.productimageurl}
            catClass={tileDetails?.catclass}
            productName={tileDetails?.producttitle}
            productAltText={tileDetails?.productAltText}
            productRatesDailyWeeklyMonthly={productRatesDailyWeeklyMonthly}
            accountNumber={accountNumber}
            footerContent={footerContent}
            handleAnchorClick={handleAnchorClick}
            handleRedirectClick={handleRedirectClick}
            specifications={tileDetails?.specifications}
            greenLeafDetails={{ isGreenLeaf: tileDetails?.isgreenleaf, greenLeafData: tileDetails?.greenleafdata }}
            {...restProps}></BaseProductTile>
    );
};

export default React.memo(ChangeDatesOrStoreGrt72Hrs);

ChangeDatesOrStoreGrt72Hrs.defaultProps = {
    tileDetails: {
        catclass: '',
        producttitle: '',
        productimageurl: '',
        producturl: '#',
        showonlinecatalog: 'YES',
        disableaddtocartoption: 'NO',
        categoryname: '',
        catsku: '',
        catid: '',
        metaTitle: '',
        metaDescription: '',
        productAltText: ''
    },
    productRatesDailyWeeklyMonthly: {},
    handleAnchorClick: () => {},
    handleRedirectClick: () => {},
    footerTileClassName: '',
    footerTileRef: () => {}
};

ChangeDatesOrStoreGrt72Hrs.propTypes = {
    tileDetails: shape({
        catclass: oneOfType([number, string]),
        producttitle: string,
        productimageurl: string,
        producturl: string,
        showonlinecatalog: string,
        disableaddtocartoption: string,
        categoryname: string,
        catsku: oneOfType([number, string]),
        catid: oneOfType([number, string]),
        metaDescription: string,
        metaTitle: string,
        productAltText: string
    }),
    productRatesDailyWeeklyMonthly: shape({
        daily: string,
        monthly: string,
        weekly: string,
    }),
    handleAnchorClick: func,
    handleRedirectClick: func,
    footerTileClassName: string,
    footerTileRef: func
};
